document.addEventListener('DOMContentLoaded', () => {
  const selectElements = document.querySelectorAll('.select--filter');
  if (selectElements) {
    selectElements.forEach((selectElement) => {
      selectElement.addEventListener('change', () => {
        const selectedValue = selectElement.value;
        if (selectedValue === 'reset') {
          // Set the selection to the first entry (index 0)
          // eslint-disable-next-line
          selectElement.selectedIndex = 0;
          if (selectElement.form) {
            // submit form on filter change
            selectElement.form.submit();
          }
        } else if (selectElement.form) {
          // submit form on filter change
          selectElement.form.submit();
        }
      });
    });
  }

  const dropdowns = document.querySelectorAll('.js-Dropdown');

  dropdowns.forEach(dropdown => {

    dropdown.addEventListener('focus', (event) => {
      dropdown.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          dropdown.querySelectorAll('.js-Dropdown-list').forEach((dropdownList) => {
            dropdownList.classList.add('is-open');
          });
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          dropdown.querySelectorAll('.js-Dropdown-list').forEach((dropdownList) => {
            dropdownList.classList.remove('is-open');
          });
        }
      });
    });

      dropdown.addEventListener('focusout', (event) => {
        if (!dropdown.contains(event.relatedTarget)) {
          dropdown.querySelectorAll('.js-Dropdown-list').forEach((dropdownList) => {
            dropdownList.classList.remove('is-open');
          });
        }
     });
  });
});
